import { Component, h, Host, Prop, Element } from '@stencil/core';
import { HTMLAnchorElementTarget } from '../../utils/helpers';

@Component({
  tag: 'vds-content-base-download',
  styleUrl: 'vds-content-base-download.scss',
  shadow: true,
})
export class VdsContentBaseDownload {

  @Element() el: HTMLElement;

  /**
   * Text that is displayed as the download link
   */
  @Prop() label: string;

  /**
   * The URL that the element points to.
   */
  @Prop() href: string;

  /**
   * Where to display the linked URL
   */
  @Prop() target: HTMLAnchorElementTarget = '_blank';

  /**
   * Prompts the user to save the linked URL instead of navigating to it.
   */
  @Prop() download: boolean = false;

  private animatedIcons: HTMLVdsAnimatedIconElement[] = [];

  componentDidLoad() {
    this.animatedIcons = Array.from(this.el.querySelectorAll('vds-animated-icon'));
  }

  render() {
    const href = this.href;
    const target = this.target;
    const download = this.download;
    const label = this.label;

    const args = {
      href,
      target
    };

    if (download) {
      args['download'] = '';
    }


    return (
      <Host>
        <div class="flex items-center">
          <div class="w-8 h-8">
            <slot name="start"></slot>
          </div>
            <a
              class="text-berry hover:text-berry-dark sm:text-base-desktop text-base-mobile"
              onMouseEnter={() => this.handleMouseEnter()}
              onMouseLeave={() => this.handleMouseLeave()}
              {...args}>
              {label}
            </a>
          <div class="w-8 h-8">
            <slot name="end"></slot>
          </div>
        </div>
      </Host>
    );
  }

  private handleMouseEnter(): void {
    this.animatedIcons.forEach(x => x.handleMouseEnter());
  }

  private handleMouseLeave(): void {
    this.animatedIcons.forEach(x => x.handleMouseLeave());
  }

}
